import React, { Component } from 'react';
//import logo from './logo.svg';
import './App.css';
import Singin from "./view/singin/singin";
import XMain from "./view/main/main";
import XMain6 from "./view/main/xpage6";
import XMain3 from "./view/main/xpage3";
import ETab14 from "./view/main/etab14";
import ETab15 from "./view/main/etab15";

import { BrowserRouter as Router, Route, Link, HashRouter, Redirect } from "react-router-dom";
import './antd.css';
import Header from "./layout/header";
import Footer from "./layout/footer";
import * as reducers from "./reducers";
import { createStore, applyMiddleware, combineReducers } from 'redux'
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { connect } from "react-redux";
import * as Actions from "./reducers/actions";
import AuthService from "./services/AuthService";
const store = createStore(combineReducers(reducers), applyMiddleware(thunk));

function mapStateToProps(state) {
  return { token: state.default.token, user: state.default.user };
}
class BasicRouter extends Component {
  constructor(props) {
    super(props);
    this.state = {}
    if (localStorage.getItem("ef_token")){
      this.props.dispatch(Actions.setToken(localStorage.getItem("ef_token")));
      AuthService.getCurrentUser().then((user)=>{
        if (user){
          let data = user ? user.profile : {};
          this.props.dispatch(Actions.setUser(data));
        }else{
          this.props.dispatch(Actions.setUser({}));
        }
      });
    }
  }
  render() {
    console.log('====================================');
    console.log("version",1);
    console.log('====================================');
    return <HashRouter>
        <div>
            {/* <Link to="/xpage6">Home</Link>/<Link to="/main">Main</Link> */}
            
                <Route exact path="/" component={Home} />
                <Route path="/main" component={XMain} />
                <Route path="/xpage6" component={XMain6} />
                <Route path="/xpage3" component={XMain3} />

                <Route path="/etab14" component={ETab14} />
                <Route path="/etab15" component={ETab15} />
     
        </div>
      </HashRouter>;
  }
};

const BasicRouterConnect = connect(mapStateToProps)(BasicRouter);

const Home = () => (
  <div>
    <Header />
    <Singin />
    <Footer />
  </div>
);

// const ETab14 = () => <div></div>;

// const ETab15 = () => <div></div>;



class App extends Component {
  render() {
    return <Provider store={store}>
        <div>
          <div className="App">
            <BasicRouterConnect/>
     
          </div>
        </div>
      </Provider>;
  }
}

export default App;





// WEBPACK FOOTER //
// ./src/App.js